import React from "react";
import { useHistory } from "react-router-dom";

import "./Template.styles.scss";
import { Button } from "../forms";
import { ReactComponent as PlusCircle } from "assets/icons/plus-in-circle-white.svg";
import { Routes } from "constants/routes";
import { useDealActions } from "store/actions-context";
import { useDealParamsHooks } from "hooks/deal-hooks/use-deal-params-hooks";
import { IHandleCreateSurvey, useCreateSurveyHook } from "hooks";
import { DealFolderForm } from "store/types";

export const Template: React.FC = () => {
  const { replace } = useHistory();
  const { createFormAction } = useDealActions();
  const { dealId, sectionId } = useDealParamsHooks();
  const handleSurveyHook: IHandleCreateSurvey = useCreateSurveyHook();

  return (
    <div className="template flex-row-fc-st">
      <div className="content flex-col-fs-fs">
        <Button title="Back" className="back-btn" onClick={() => replace(Routes.myDeals)} />
        <div className="blank flex-col-fc-fc">
          <span className="title">DDQ QUESTIONNAIRE</span>
          <div
            onClick={async () => {
              const data: DealFolderForm = await createFormAction({
                dealId,
                sectionId
              });
              handleSurveyHook(data);
            }}
            className="start-btn flex-row-fs-fc scale-click"
          >
            <PlusCircle className="icon" />
            <span>START A NEW TEMPLATE</span>
          </div>
        </div>
      </div>
    </div>
  );
};
